export const scrollingLogoBandRefName = 'scrollingLogoBandRef';

export const scrollingLogoBandRefProjection = `{
  _id,
 title,
 logos,
}`;

export const scrollingLogoBandRefQuery = groq`*[_id == $_id][0] ${scrollingLogoBandRefProjection}`;
